/* import __COLOCATED_TEMPLATE__ from './display-context.hbs'; */
import Component from '@glimmer/component';
import { camelize } from '@ember/string';
import { inject as service } from '@ember/service';
import * as ContextUtils from '../utils/context';
import type Results from 'filter-wizard/models/results/results';
import type IntlService from 'ember-intl/services/intl';

interface DisplayContextArgs {
  tab: string;
  model: Results;
}

type ContextFunctionType =
  | '_filterTypeContext'
  | '_specificationsContext'
  | '_componentsContext'
  | '_tolerancesContext'
  | '_nextStepsContext';

export default class DisplayContext extends Component<DisplayContextArgs> {
  @service declare intl: IntlService;

  get contextText(): string {
    return this[('_' + camelize(this.args.tab) + 'Context') as ContextFunctionType](this.args.model);
  }

  _filterTypeContext(): string {
    return ContextUtils.filterSummary(null, this.intl);
  }
  _specificationsContext(model: Results): string {
    return ContextUtils.filterSummary(model.filter, this.intl);
  }
  _componentsContext(model: Results): string {
    return ContextUtils.specificationsSummary(model.specifications, this.intl);
  }
  _tolerancesContext(model: Results): string {
    return ContextUtils.componentsSummary(model.components, this.intl);
  }
  _nextStepsContext(model: Results): string {
    return ContextUtils.tolerancesSummary(model.tolerances, this.intl);
  }
}
